// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: center;
  align-items: center;
  height: 100%;
  padding: 25px 30px;
  text-align: center;
}
.container h4 {
  font-weight: bold;
  margin: 0;
}
.container span {
  font-weight: light;
  color: #666;
  font-size: 12px;
  white-space: pre-line;
}`, "",{"version":3,"sources":["webpack://./src/app/modals/error-modal/error-modal.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AACJ;AAAI;EACI,iBAAA;EACA,SAAA;AAER;AAAI;EACI,kBAAA;EACA,WAAA;EACA,eAAA;EACA,qBAAA;AAER","sourcesContent":[".container { \n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    justify-content: center;\n    align-items: center;\n    height: 100%;\n    padding: 25px 30px;\n    text-align: center;\n    h4 { \n        font-weight: bold;\n        margin: 0;\n    }\n    span {\n        font-weight: light;\n        color : #666;\n        font-size: 12px;\n        white-space: pre-line;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
